"use client";

import { MediaEnum } from "./enums";
import { getFormattedFileSize } from "utils";
import { CircularProgressbar } from "react-circular-progressbar";
import type { VideoItemType, PhotoItemType } from "./types";
import { isVideoItem } from "./helpers";

import "react-circular-progressbar/dist/styles.css";

interface IProgressBarProps {
  items: (VideoItemType | PhotoItemType)[];
  unProcessedIdsInCurrentPeriod: string[];
  unProcessedIds: string[];
}

export default function ProgressBar({
  items = [],
  unProcessedIdsInCurrentPeriod = [],
  unProcessedIds = [],
}: IProgressBarProps) {
  const getUnProcessedItemsInCurrentPeriod = () =>
    unProcessedIdsInCurrentPeriod.map((unProcessedId) => {
      return items.find((item) => item.id === unProcessedId);
    });
  const getTotalBytes = () =>
    getUnProcessedItemsInCurrentPeriod().reduce((acc, item) => {
      if (item) {
        return acc + item.fileLength;
      }

      return acc;
    }, 0);
  const getProcessedBytes = () =>
    getUnProcessedItemsInCurrentPeriod().reduce((acc, item) => {
      if (item && item.mediaType === MediaEnum.Photo && item.uploaded) {
        return acc + item.fileLength;
      }

      if (item && isVideoItem(item)) {
        return acc + item.uploaded;
      }

      return acc;
    }, 0);
  const percentage = Math.round((getProcessedBytes() / getTotalBytes()) * 100);
  const styles = {
    trail: { stroke: "rgba(16, 44, 87, 0.5)" },
    path: { stroke: "rgb(16, 44, 87)" },
    text: { fill: "rgb(16, 44, 87)", fontSize: "24px" },
  };

  if (unProcessedIdsInCurrentPeriod.length === 0) {
    return "";
  }

  return (
    <div className="mb-3 text-center text-primary bg-primary/10 border border-primary/20 p-2 rounded-md">
      <div className="w-[60px] h-[60px] mx-auto font-semibold">
        <CircularProgressbar
          value={percentage}
          text={`${percentage}%`}
          styles={styles}
        />
      </div>

      <p>Items remaining: {unProcessedIds.length}</p>
      <p className="font-bold">
        {getFormattedFileSize(getProcessedBytes())} /{" "}
        {getFormattedFileSize(getTotalBytes())}
      </p>
    </div>
  );
}
